// extracted by mini-css-extract-plugin
export default {"Container":"Referral_Container__xU2-f","info":"Referral_info__GzEaG"};